/**
 * @generated SignedSource<<49dd62b972c8f8cc0cb2db71e405aa8c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useProfile_query$data = {
  readonly currentUser: {
    readonly profile: {
      readonly beliefSystemId: any | null | undefined;
      readonly biography: string | null | undefined;
      readonly childrenPreferenceId: any | null | undefined;
      readonly closestCity: string | null | undefined;
      readonly educationLevelId: any | null | undefined;
      readonly genderId: any | null | undefined;
      readonly genderOther: string | null | undefined;
      readonly heightCm: number | null | undefined;
      readonly heightFt: number | null | undefined;
      readonly heightIn: number | null | undefined;
      readonly instagram: string | null | undefined;
      readonly occupation: string | null | undefined;
      readonly politicalViewId: any | null | undefined;
      readonly pronounId: any | null | undefined;
      readonly rowId: any;
      readonly school: string | null | undefined;
      readonly vaccinationStatusId: any | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"OwnProfileInfo_profile">;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useProfile_query";
};
export type useProfile_query$key = {
  readonly " $data"?: useProfile_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"useProfile_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useProfile_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Profile",
          "kind": "LinkedField",
          "name": "profile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "beliefSystemId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "biography",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "childrenPreferenceId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "closestCity",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "educationLevelId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "genderId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "genderOther",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "heightCm",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "heightFt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "heightIn",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "instagram",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "occupation",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "politicalViewId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pronounId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rowId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "school",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "vaccinationStatusId",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "OwnProfileInfo_profile"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "5e9bf277d2e3023a4fa453b0174b70bd";

export default node;
